export default "__VITE_ASSET__946b22ba__"